import { outwardJobWorkBillAddApi } from "../../api/outwardJobWorkBill/outwardJobWorkBillAddApi"

type PayloadShape = Parameters<typeof outwardJobWorkBillAddApi>[0]

export async function outwardJobWorkBillAddService(payload: PayloadShape, token: string) {
	return await outwardJobWorkBillAddApi(payload, token)
}
